import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconTrashOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M31 7h-7V3c0-1.1-.9-2-2-2H10c-1.1 0-2 .9-2 2v4H1c-.56 0-1 .44-1 1s.44 1 1 1h3v20c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V9h3c.56 0 1-.44 1-1s-.44-1-1-1M10 3h12v4H10zm16 26H6V9h20z" /><path fill="currentColor" d="M11 19c-.56 0-1 .44-1 1v6c0 .56.44 1 1 1s1-.44 1-1v-6c0-.56-.44-1-1-1m5-4c-.56 0-1 .44-1 1v10c0 .56.44 1 1 1s1-.44 1-1V16c0-.56-.44-1-1-1m5 4c-.56 0-1 .44-1 1v6c0 .56.44 1 1 1s1-.44 1-1v-6c0-.56-.44-1-1-1" /></svg>;
export default SvgIconTrashOutlined;